var _path, _path2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPwdEyeSlash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.57776 12.4831C3.4386 12.3026 3.31766 12.1399 3.21623 12C3.31766 11.8601 3.4386 11.6974 3.57776 11.5169C4.06288 10.8878 4.76301 10.0516 5.62409 9.21885C7.38594 7.51508 9.64197 6 12 6C14.358 6 16.6141 7.51508 18.3759 9.21885C19.237 10.0516 19.9371 10.8878 20.4222 11.5169C20.5614 11.6974 20.6823 11.8601 20.7838 12C20.6823 12.1399 20.5614 12.3026 20.4222 12.4831C19.9371 13.1122 19.237 13.9484 18.3759 14.7811C16.6141 16.4849 14.358 18 12 18C9.64197 18 7.38594 16.4849 5.62409 14.7811C4.76301 13.9484 4.06288 13.1122 3.57776 12.4831Z",
    stroke: "#313131",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.99999 4.00001L20 20",
    stroke: "#313131",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.9996,
    cy: 12,
    r: 3,
    transform: "rotate(-45 11.9996 12)",
    stroke: "#313131",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPwdEyeSlash);
export default __webpack_public_path__ + "static/media/pwdEyeSlash.6cea1f0620554d98842e7f7049c42e70.svg";
export { ForwardRef as ReactComponent };